import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
var path = '/Home/userList'
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)
//console.log(flag);
const routes = [
  {
    path: "",
    redirect: "/dologin"
  },

  {
    path: "/dologin",
    name: "dologin",
    component: () => import("../views/doLogin.vue"),
    meta: {
      title: "登录"
    }
  },

  {
    path: "/Home",
    name: 'Home',
    component: () => import("../views/Home.vue"),
    children: [
      {
        path: "",
        redirect: path
      },
      
      {
        path: 'userList',
        name: 'userList',
        component: () => import('../views/user/userList'),
      },
      {
        path: 'SystemLog',
        name: 'SystemLog',
        component: () => import('../views/SystemLog/SystemLog'),
      },
     
     
      {
        path: 'newTopicAnswer',
        name: 'newTopicAnswer',
        component: () => import('../views/bank/newTopicAnswer.vue'),
      },
      {
        path: 'topicAnswer',
        name: 'topicAnswer',
        component: () => import('../views/bank/topicAnswer.vue'),
      },
      {
        path: 'testPaper',
        name: 'testPaper',
        component: () => import('../views/bank/testPaper.vue'),
      },
      {
        path: 'AnswerResult',
        name: 'AnswerResult',
        component: () => import('../views/bank/AnswerResult.vue'),
      },
      {
        path: 'gridUser',
        name: 'gridUser',
        component: () => import('../views/gridUser/gridUser.vue'),
      },
      {
        path: 'pkTime',
        name: 'pkTime',
        component: () => import('../views/pkTime/pkTime.vue'),
      },
      {
        path: 'videoList',
        name: 'videoList',
        component: () => import('../views/videoList/videoList.vue'),
      },
    ]
  },
]


const router = new VueRouter({
  routes
})

export default router
